module.exports = __webpack_public_path__ + "img/49fec82ebdd31502ff662c3e319f59ca.png";